import React, { useState, useEffect } from "react";
import axios from "axios";
import Select from "react-select";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const MouOutcome = () => {
    const [formData, setFormData] = useState({
        mouId: "",
        particulars: "",
        outcomeDate: "",
        description: ""
    });
    const [mous, setMous] = useState([]);
    const [errors, setErrors] = useState({});
    useEffect(() => {
        const fetchData = async () => {
          try {
            // Retrieve `selectedMouId` from sessionStorage
            const storedMouId = sessionStorage.getItem("selectedMouId");
            if (storedMouId) {
              setFormData((prevFormData) => ({
                ...prevFormData,
                mouId: storedMouId,
              }));
            }
      
            // Fetch MOU data to get the total elements
            const firstFetch = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/mous`);
            const totalElements = firstFetch.data.page.totalElements;
      
            // Fetch MOU options (no pagination needed)
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/mous?size=${totalElements}`);
      
            const mouOptions = response.data._embedded.mous
              .filter((mou) => mou.mouId)
              .map((mou) => ({
                value: mou.mouId,
                label: `${mou.mouId} - ${mou.ptnOrg}`,
              }));
            setMous(mouOptions);
          } catch (error) {
            console.error("Error fetching MOU options:", error);
            toast.error("There was an error fetching the MOU options!");
          }
        };
      
        fetchData();
      }, []); // No dependency, so it runs only once on component mount
      

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSelectChange = (selectedOption, fieldName) => {
        let selectedValues = "";

        if (Array.isArray(selectedOption)) {
            selectedValues = selectedOption.map(option => option.value).join(", ");
        } else {
            selectedValues = selectedOption ? selectedOption.value : "";
        }

        setFormData({
            ...formData,
            [fieldName]: selectedValues
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        let newErrors = {};
        if (!formData.mouId) newErrors.mouId = "MOU ID is required.";
        if (!formData.outcomeDate) newErrors.outcomeDate = "Outcome Date is required.";
        if (!formData.particulars) newErrors.particulars = "Particulars are required.";
        if (!formData.description) newErrors.description = "Description is required.";

        setErrors(newErrors);

        if (Object.keys(newErrors).length === 0) {
            axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/mouOutcomes`, formData)
                .then(() => {
                    toast.success("MOU Outcome saved successfully!");
                    setFormData({
                        mouId: "",
                        particulars: "",
                        outcomeDate: "",
                        description: "",
                    });
                    setTimeout(() => {
                        window.history.back();
                    }, 2000);
                })
                .catch(error => {
                    console.error("Error submitting the form!", error);
                    toast.error("There was an error submitting the form!");
                });
        }
    };

    const particularsOptions = [
        { value: "Industrial", label: "Industrial" },
        { value: "Internship", label: "Internship" },
        { value: "Project", label: "Project" },
        { value: "Placement", label: "Placement" },
        { value: "Product Development", label: "Product Development" }
    ];

    return (
        <div className="container mt-5">
            <h2 className="mb-4">MOU Outcome</h2>
            <form onSubmit={handleSubmit}>
                <div className="row mb-3">
                    <div className="col-md-6">
                        <label htmlFor="mouId" className="form-label">
                            MOU ID, ORGANIZATION: <span style={{ color: 'red', fontSize: '20px' }}>*</span>
                        </label>
                        <Select
                            options={mous}
                            name="mouId"
                            className="basic-single"
                            placeholder="Select MOU"
                            onChange={(selectedOption) => handleSelectChange(selectedOption, "mouId")}
                            value={mous.find(option => option.value === formData.mouId)}
                        />
                        {errors.mouId && <small className="text-danger">{errors.mouId}</small>}
                    </div>

                    <div className="col-md-6">
                        <label htmlFor="outcomeDate" className="form-label">
                            Outcome Date: <span style={{ color: 'red', fontSize: '20px' }}>*</span>
                        </label>
                        <input
                            type="date"
                            name="outcomeDate"
                            value={formData.outcomeDate}
                            onChange={handleChange}
                            className="form-control"
                        />
                        {errors.outcomeDate && <small className="text-danger">{errors.outcomeDate}</small>}
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-md-6">
                        <label htmlFor="particulars" className="form-label">
                            Particulars: <span style={{ color: 'red', fontSize: '20px' }}>*</span>
                        </label>
                        <Select
                            options={particularsOptions}
                            name="particulars"
                            className="basic-single"
                            placeholder="Select Particulars"
                            onChange={(selectedOption) => handleSelectChange(selectedOption, "particulars")}
                            value={particularsOptions.filter(option => formData.particulars.split(", ").includes(option.value))}
                            isMulti
                        />
                        {errors.particulars && <small className="text-danger">{errors.particulars}</small>}
                    </div>
                    
                    
                    
                </div>

                <div className="mb-3">
                    <label htmlFor="description" className="form-label">
                        Description: <span style={{ color: 'red', fontSize: '20px' }}>*</span>
                    </label>
                    <textarea
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                        className="form-control"
                        rows="5"
                    />
                    {errors.description && <small className="text-danger">{errors.description}</small>}
                </div>

                <div style={{ textAlign: 'right' }}>
                    <button
                        type="submit"
                        className="btn btn-primary"
                        style={{
                            backgroundColor: '#1E88E5',
                            color: '#fff',
                            padding: '6px 12px',
                            fontSize: '0.875rem',
                            borderRadius: '6px',
                            border: 'none',
                            cursor: 'pointer',
                            width: '150px',
                        }}
                    >
                        Submit
                    </button>
                </div>
            </form>
            <ToastContainer />
        </div>
    );
};

export default MouOutcome;
